var _circle, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup22088(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22088",
    "data-name": "Group 22088",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1469",
    "data-name": "Ellipse 1469",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#fbe7e7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "i",
    transform: "translate(5 9)",
    fill: "#e83d3d",
    fontSize: 9,
    fontFamily: "Ubuntu-Regular, Ubuntu"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22088);
export default __webpack_public_path__ + "static/media/Group 22088.9251759d896a5957e0700db031b2d3d8.svg";
export { ForwardRef as ReactComponent };